import type { ArTaskRow, ArTasksSummaryResponse, ArTasksTab } from '@erp/rpc';
import type { ColumnDef, ReactTable } from '@/lib/tanstack-table';
import { arTasksColumnLabels } from './arTasksColumns';
import { arTasksTabCounts, nextAgingBucket } from './arTasksPageState';
import type { ArTasksSearch } from './arTasksSearch';
import { ArTasksSummaryCards } from './ArTasksSummaryCards';
import { ArTasksTabs } from './ArTasksTabs';
import { ArTasksToolbar } from './ArTasksToolbar';

/**
 * Everything above the table: metric cards, then tabs and the toolbar. It
 * stays while a task is open; only the table turns into the list and detail.
 */
export function ArTasksListHeader({
  summary,
  summaryLoading,
  search,
  tab,
  table,
  columns,
  onResetLayout,
  onOpenRules,
  onSearchChange,
}: {
  summary: ArTasksSummaryResponse | undefined;
  summaryLoading: boolean;
  search: ArTasksSearch;
  tab: ArTasksTab;
  table: ReactTable<ArTaskRow>;
  columns: ColumnDef<ArTaskRow>[];
  onResetLayout: () => void;
  onOpenRules?: () => void;
  onSearchChange: (updates: Partial<ArTasksSearch>) => void;
}) {
  function pickTab(next: ArTasksTab) {
    onSearchChange({ tab: next === 'all' ? undefined : next });
  }
  return (
    <>
      <ArTasksSummaryCards
        summary={summary}
        isLoading={summaryLoading}
        activeAging={search.aging}
        onPickTab={pickTab}
        onPickAging={(bucket) =>
          onSearchChange({ aging: nextAgingBucket(search.aging, bucket) })
        }
      />
      <div className="space-y-4">
        <ArTasksTabs
          value={tab}
          counts={arTasksTabCounts(summary)}
          onChange={pickTab}
        />
        <ArTasksToolbar
          table={table}
          search={search}
          columnLabels={arTasksColumnLabels(columns)}
          onResetLayout={onResetLayout}
          onOpenRules={onOpenRules}
          onChange={onSearchChange}
        />
      </div>
    </>
  );
}
